export default __webpack_public_path__ + "static/media/breastfeeding.017706f2.svg";